import { chatEE } from '@/layout';
import { confirmMes } from '@/shared/utilities';
import i18next from 'i18next';
import { useCallback, useEffect, useState } from 'react';

export const useConversationAdd = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const openHandler = () => setShow(true);
    chatEE.on('conversation-add', openHandler);
    return () => {
      chatEE.off('conversation-add', openHandler);
    };
  }, []);

  const handleClose = useCallback(async (hasUnsavedChanges: boolean, handleReset: () => void) => {
    if (hasUnsavedChanges) {
      const confirm = await confirmMes({
        title: i18next.t('conversations.settings.unsavedChangesTitle'),
        description: i18next.t('conversations.settings.unsavedChangesDescription')
      });
      if (!confirm) return;
    }
    setShow(false);
    handleReset();
  }, []);

  return {
    show,
    setShow,
    handleClose
  };
};
